import { useEffect, useState } from "react";
import { ROUTES } from "utils/constants";
import { NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "slices/user";
import { getWalletBalance } from "slices/payment";
import { AppConfirm } from "components/app-confirm";

const AppSubHeader = () => {
    const location = useLocation();
    const { baseCurrency } = useSelector(
        (state) => state.user
    );
    const { currentBalance } = useSelector((state) => state.payment);
    const { data } = useSelector((state) => state.projects);
    const [modalTitle, setModalTitle] = useState("");
    const [modalText, setModalText] = useState("");
    const [modalShow, setModalShow] = useState(false);

    const isProjectsPage = location.pathname === "/" + ROUTES.PROJECT;

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getWalletBalance());
    }, []);

    const userLogout = () => {
        setModalShow(true);
        setModalTitle("Logout");
        setModalText("Are you sure you want to log out? ");
    };

    const onConfirmLogoutClick = () => {
        dispatch(logout({ mode: "manual" }));
    }

    return (
        <>
            <div
                className={(isProjectsPage && data && data.length > 0) ?
                    "col-12 col-sm-10 col-md-12 top-block-btns ms-auto"
                    : "col-12 col-sm-10 top-block-btns ms-auto"}>
                <span className="c-balance">
                    <p>CURRENT BALANCE : </p>
                    {" "}
                    {baseCurrency}{" "}
                    {currentBalance.toLocaleString(undefined, {
                        maximumFractionDigits: 6,
                    })}
                </span>
                <div className="top-btns-list">
                    <NavLink
                        to={"/" + ROUTES.PROJECT}
                        className="img-box" title="Projects">
                        <img src="/assets/images/icons/package-s-1.svg" alt="" />
                        <img src="/assets/images/icons/package-s-2.svg" alt="" />
                    </NavLink>
                    <NavLink
                        to={"/" + ROUTES.ACTIVITIES}
                        className="img-box" title="Activites">
                        <img src="/assets/images/icons/activities-s-1.svg" alt="" />
                        <img src="/assets/images/icons/activities-s-2.svg" alt="" />
                    </NavLink>
                    <NavLink
                        to={"/" + ROUTES.LIMITS}
                        className="img-box" title="Limits">
                        <img src="/assets/images/icons/limits-s-1.svg" alt="" />
                        <img src="/assets/images/icons/limits-s-2.svg" alt="" />
                    </NavLink>
                    {/* <a href="#" className="img-box">
                    <img src="/assets/images/icons/support-s-1.svg" />
                    <img src="/assets/images/icons/support-s-2.svg" />
                </a> */}
                    <NavLink
                        to={"/" + ROUTES.ACCOUNT_SETTINGS}
                        className="img-box" title="Account Settings">
                        <img src="/assets/images/icons/account-s-1.svg" alt="" />
                        <img src="/assets/images/icons/account-s-2.svg" alt="" />
                    </NavLink>
                    <span className="img-box"
                        onClick={() => userLogout()}
                        title="Logout"
                    >
                        <img src="/assets/images/icons/log-out-s-1.svg" alt="" />
                        <img src="/assets/images/icons/log-out-s-2.svg" alt="" />
                    </span>
                </div>
            </div>

            <AppConfirm
                modaltitle={modalTitle}
                closeModal={false}
                modalsubtitle={modalText}
                onSubmit={onConfirmLogoutClick}
                size="md"
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>

    )
}

export default AppSubHeader;